import { Inject, Injectable, SimpleChanges } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { AuthService } from '../../auth/auth/auth.service';
import { AppConfigService } from '../../shared/appconfig/appconfig.service'

import { Help } from '../../shared/models/core.model';

@Injectable({
  providedIn: 'root'
})
export class HelpService {

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    @Inject('BASE_URL') baseUrl: string) {
  }

  private headers: HttpHeaders;

  get(category, item): Promise<Help> {
    return this.authService.getManager().getUser().then(user => {
      if (!user) {
        // Optionally reject or return null/undefined
        return Promise.reject('User not authenticated');
      }
      this.headers = new HttpHeaders({ 'Authorization': this.authService.getAuthorizationHeaderValue() });
      return this.http.get<Help>(AppConfigService.settings.get('chatstyleapiServer') + 'help/' + category + '/' + item,
        { headers: this.headers }).toPromise();
    });
  }



}


